module.exports = __webpack_public_path__ + "img/certificates-icon.9f2b0d98.svg";